/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import './shared/directives/index';

import Vue from 'vue';
import ConfigCenter from '@hb/tangram-js-sdk';
import {
  isPro, isH5App,
} from '@/constant';
import { Toast } from '@hb/coffee';
import { initRequest } from '@/shared/utils/request';
import { downloadOcrSDKFirst } from '@/shared/tools/ocr/utils/download';
import App from './App';
import store from './store';
import router from './router';
import Bootstrap from './shared/utils/bootstrap';
import {
  ubtModuleExpose, ubtModuleExposeNew, ubtPageButton, ubtPageButtonNew, ubtCustomEvent,
} from './shared/utils/ubt';
import { formatToastOption } from './shared/utils/formatToast';
import isPrerendering from './shared/utils/isPrerendering';
import platform from './shared/utils/platform';
import LoginUtil from './viewsH5/login/LoginUtils';
import { markLaunchTimes } from './api/native/utils';

// 在主逻辑最前面，优先下载OCR SDK，保障下载时机最早
downloadOcrSDKFirst();

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

Vue.config.productionTip = !isPro;

const appVersion = (new RegExp('version=([0-9.]*)').exec(navigator.userAgent) || [])[1] || '1.0.0';

// 初始化request，由于项目中存在直接引用@hb/sharp-request的request场景 ，所以这里也需要初始化一次
initRequest();

// 七巧板配置sdk
Vue.prototype.$tangram = new ConfigCenter({
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  env: process.env.VUE_APP_ENV_TANGRAM!,
  appVersion,
  appCode: 'HELLOAPP', // 哈啰出行
  platformCode: 'H5', // 平台类型
});

// 统一封装埋点-点击
Vue.prototype.$ubtPageButton = function ubtPageButtonFunc(
  buttonName: string,
  ...otherProps: string[]
) {
  ubtPageButton(this, buttonName, ...otherProps);
};

Vue.prototype.$ubtPageButtonNew = function ubtPageButtonFunc(
  buttonName: string,
  otherProps: Dictionary,
) {
  ubtPageButtonNew(this, buttonName, otherProps);
};

// 统一封装埋点-曝光
Vue.prototype.$ubtModuleExpose = function ubtModuleExposeFunc(
  buttonName: string,
  ...otherProps: string[]
) {
  ubtModuleExpose(this, buttonName, ...otherProps);
};

// 统一封装埋点-曝光
Vue.prototype.$ubtModuleExposeNew = function ubtModuleExposeFunc(
  buttonName: string,
  otherProps: Dictionary,
) {
  ubtModuleExposeNew(this, buttonName, otherProps);
};

// 统一封装埋点-自定义事件
Vue.prototype.$ubtCustomEvent = function ubtCustomEventFunc(
  customPointId: string,
  extraParams: Dictionary,
) {
  ubtCustomEvent(this, customPointId, extraParams);
};


const getSelector = (initialRoute?: string): string => `#app[initial-route="${initialRoute || 'default'}"]`;

/**
 * 系统数据初始化，包括：source、手机号、登录信息、地理位置信息、设备信息等；
 */
Bootstrap.init()
  .then(() => {
    let hydrating = false;
    let selector = getSelector();

    const prerenderSelector = getSelector(window._INITIAL_ROUTE);

    // 只有当节点存在的时候，在指定预渲染节点，否则使用默认的空容器进行挂载
    if (document.querySelector(prerenderSelector)) {
      selector = prerenderSelector;
    }

    if (
      !isPrerendering()
      // 如果是H5浏览器在未登陆的情况下，会渲染登录页面内容，和模版不一致导致出现异常提示：
      // Failed to append child on Node: ***
      && ((!isH5App || !platform.isDingTalk) || LoginUtil.isLogin())
    ) {
      hydrating = true;
    }

    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount(selector, hydrating);
  })
  .catch((error) => {
    Toast.fail(formatToastOption(error.message || '服务初始化失败'));
  });

// 页面启动时对投放链路启动流程中的时间点位进行埋点
markLaunchTimes();
